import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import { CreateOrderParams } from 'src/features/orders/data/service/OrdersService.types';
import { PaymentMethodSlug } from 'src/types/common';

export interface CreateEfektivaOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreateEfektivaOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreateEfektivaOrderUseCaseParams) {
    return await this.ordersRepository.createOrder({
      ...params,
      payment_method: PaymentMethodSlug.PariCredit,
    });
  }
}

export default CreateEfektivaOrderUseCase;
